<template>
  <div class="download" :class="{ onlyitem: onlyItem, generating: isGenerating }">
    <a class="download-link more-black" @click="onDownload" :data-payload="file.payload || file.url"
      :data-protected="file.isProtected || 'false'" v-if="!isGenerating" :data-targetid="downloadFormId">{{ fileName
      }}</a>
    <div class="generating-message">{{ labels.generating }}</div>
  </div>
</template>

<script>
import { Settings } from "./services/settings.js";
import { Utils } from "./services/utils.js";
import { Labels } from "./services/labels.js";
import { Bus } from './services/bus.js'
import axios from "axios";

export default {
  name: "DownloadFile",
  props: ["file", "only-item", "parent-number", "parent-name"],
  data() {
    return { isGenerating: false, canDownload: true, labels: Labels, downloadFormId: "" };
  },
  computed: {
    fileName() {
      const file = this.$props.file;
      if (!file) return "";
      if (file.regionName) {
        let name = Settings.sdsFileTitleFormat;
        name = name.replace("{country}", file.regionName);
        name = name.replace("{version}", file.versionText);
        name = name.replace("{language}", file.languageName);
        return name;
      } else {
        return `${file.title} ${file.size}`;
      }
    }
  },
  mounted() {
    //we just take the first download form on the page, if one exists
    let el = document.querySelector(".download-form-popup.overlay");
    if (el) {
      this.downloadFormId = el.id;
    }
    Bus.$on("download-started", (e) => {
      this.canDownload = false;
    });
    Bus.$on("download-complete", (e) => {
      this.canDownload = true;
    });
  },
  methods: {
    updateMaterialNumber(file, parent) {
      if (!file || !file.url) return "";
      if (!parent) return file.url;
      //if this is the main product, we don't do anything
      if (parent.length === 6) return file.url;
      let paddedParent = parent.padStart(18, "0");
      return file.url.replace(file.materialNumber, paddedParent);
    },
    updateFileName(original, parent) {
      if (!original) return "";
      if (!parent) return "";
      var safeName = Utils.makeSafe(parent);
      return original.replace(this.$props.file.materialName, safeName);
    },
    onDownload(ev) {
      const file = this.$props.file;
      if (!file) return;

      //this is an SDS...we trigger the generation and download it in memory, then we save it
      let self = this;
      if (self.isGenerating) {
        //we avoid accidental double-clicks
        return;
      }

      if (!this.canDownload) {
        Utils.showStatusMessage(Labels.pleaseWait, "yellow");
        return;
      }

      Bus.$emit("download-started");
      self.isGenerating = true;
      if (file.isProtected && file.payload && this.downloadFormId) {
        console.log("This seems to be an EH&S file. Falling back to the download box behavior.");
        //this should be caught by the download form
        //so we just spin the loader for 5 seconds
        let actualFormId = this.downloadFormId.indexOf("download_form_") === 0 ? this.downloadFormId.substring(14) : this.downloadFormId;
        window.cla && window.cla.component &&
          window.cla.component.portlet &&
          window.cla.component.portlet.downloadform &&
          window.cla.component.portlet.downloadform.downloadPayload(file.payload, file.isProtected, actualFormId);
        setTimeout(() => {
          self.isGenerating = false;
        }, 15000);
      } else {
        let modifiedUrl = self.updateMaterialNumber(file, self.$props.parentNumber);
        self.downloadFile(modifiedUrl)
          .then(res => {
            Bus.$emit("download-complete");
            self.isGenerating = false;
            if (res.data) {
              var blob = new Blob([res.data], { type: "application/pdf" });
              var link = document.createElement('a');
              var fileName = self.updateFileName(file.fileName, self.$props.parentName);
              if (window.navigator.msSaveOrOpenBlob) {
                link.onclick = function (e) {
                  window.navigator.msSaveOrOpenBlob(blob, fileName);
                }
              } else {
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
              }

              document.body.appendChild(link);

              link.click();

              document.body.removeChild(link);
              Utils.reportToAnalytics({ description: "SDS Download", category: "Global Search", value: fileName });
            }
          })
          .catch(err => {
            Bus.$emit("download-complete");
            self.isGenerating = false;
            Utils.showStatusMessage(`Unable to generate file: ${err}`, "red");
          });
      }
    },
    downloadFile(url) {
      return axios.get(url, {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/pdf'
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.download {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTS40MiAxNC4zMTZIMTUuNThWMTZILjQydi0xLjY4NFptOC40MjItNC45MDggNS4xMTItNS4xMTMgMS4xOTEgMS4xOUw4IDEyLjYzMi44NTUgNS40ODZsMS4xOS0xLjE5MSA1LjExMyA1LjExMVYwaDEuNjg0djkuNDA4WiIgZmlsbD0iIzI2NTVGRiIvPjwvc3ZnPg==);
  background-position: 100%;
  background-repeat: no-repeat;
  background-size: 15px 15px;
  margin-right: 5px;
  padding: 11px 0 0;
  border-bottom: 1px solid #323232;
    height: 45px;
    width: 100%;
}

.download.generating {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg class='lds-spinner' width='64px' height='64px' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' style='background: none;'%3E%3Cg transform='rotate(0 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.9166666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(30 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.8333333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(60 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.75s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(90 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.6666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(120 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5833333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(150 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(180 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.4166666666666667s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(210 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.3333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(240 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.25s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(270 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.16666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(300 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.08333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(330 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='0s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3C/svg%3E");
  background-size: 32px;
  background-position: 100% center;
}

/*.download:first-of-type,
.onlyitem.download {
  border-top: 1px solid #c9c9c9;
}*/

.download-link {
  background-image: none;
  background-position: 0 5px;
  background-repeat: no-repeat;
  color: #323232;
  cursor: pointer;
  display: block;
  font-family: Gotham Narrow, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 300;
  font-weight: 400;
  line-height: 19px;
  overflow: hidden;
  padding: 2px 45px 2px 0;
  text-overflow: ellipsis;
  text-transform: capitalize;
  white-space: nowrap;
}

.download-link>div {
  display: flex;
  justify-content: space-between;
}

.generating-message {
  padding-right: 35px;
  font-family: 'Gotham SSm A', 'Gotham SSm B', sans-serif;
  font-size: 13px;
  line-height: 19px;
  display: none;
}

.download.generating .generating-message {
  display: block;
}

@media all and (max-width: 780px) {
  .download.generating>a {
    display: none;
  }
}
</style>